import React, {
  useCallback, useState, MutableRefObject,
} from 'react';
import {
  Select, MenuItem, Grid, Box,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { selectCurrentSceneId, selectListScenes } from '../../../../store/modules/scenes/selectors';
import { setCurrentSceneId } from '../../../../store/modules/scenes/actions';
import {
  setBookmarkPosition,
  setPlayPrompter,
  setDropdownSelectMode,
} from '../../../../store/modules/studio/actions';
import { StudioControlStyles } from '../../styles';
import { updateQuery } from '../../../../utility/helpers';
import StartDelayAction from '../../actions/StartDelayAction';
import StudioToolTip from '../../actions/StudioToolTip';
import StyledInput from '../../actions/StyledInput';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};

const ScriptListAction = ({ refPrompter }: Props) => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const scriptList = useSelector(selectListScenes);
  const currentSceneId = useSelector(selectCurrentSceneId);

  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>, _) => {
    if (refPrompter.current) {
      // eslint-disable-next-line
      const scriptId = event.target.value as number;
      updateQuery({ scriptId });
      dispatch(setBookmarkPosition(null));
      dispatch(setPlayPrompter(false));
      dispatch(setCurrentSceneId(scriptId));
      refPrompter.current.scrollTo({ top: 0 });
    }
  }, [dispatch, refPrompter]);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);

  if (scriptList.data?.items.length === 0) {
    return null;
  }

  return (
    <Grid container direction="row" item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
      <StudioToolTip title="Change to a different script text">
        <Box mr={2} mt={2} className={classes.selectionWrapper}>
          <p className={classes.label}>Script</p>
          <Select
            open={open}
            data-tip="Change to a different script text"
            variant="outlined"
            className={classes.selection}
            input={<StyledInput />}
            value={currentSceneId}
            onChange={onChange}
            MenuProps={{
              style: {
                zIndex: 2147483101,
              },
            }}
            data-intercom-target="Dropdown: Script"
            onOpen={openHandler}
            onClose={closeHandler}
          >
            {scriptList.data?.items.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.title}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </StudioToolTip>
      <StartDelayAction/>
    </Grid>
  );
};

export default ScriptListAction;
